import { createSlice } from "@reduxjs/toolkit";
import { English } from "../../Languages/en";
import { Gujarati } from "../../Languages/gujarati";
// console.log(English, "dddddddddd");

const initialState = {
  selectedLanguage: English, // Default language
  selectedLanguageNumber: 1,
};
// console.log(initialState.selectedLanguage, "llllllllll");
// console.log(initialState.selectedLanguageNumber, "kjkjkjk");
const languageSlice = createSlice({
  name: "languageReducer",
  initialState,
  reducers: {
    setSelectedLanguage: (state, action) => {
      state.selectedLanguage = action.payload;
    },
    setLanguageNumber: (state, action) => {
      state.selectedLanguageNumber = action.payload;
    },
  },
});

export const { setSelectedLanguage, setLanguageNumber } = languageSlice.actions;
export default languageSlice.reducer;
